/**
 * Cas (clé ↔ libellé) des champs codés d'une convention.
 *
 * Le backend stocke une clé numérique et renvoie le libellé au GET ; ces tables
 * servent à la fois de source des listes déroulantes d'édition et de référentiel
 * pour retrouver la clé depuis le libellé (voir `resolveCasCode`).
 *
 * ⚠️ Les libellés doivent rester identiques à ceux du backend, sinon la
 * résolution libellé → clé échoue et retombe sur 0 (« Non renseigné »).
 */

export type CasCode = { key: number; text: string; value: number };

export const OPTIONS_TYPE_CONVENTION_FICHE: CasCode[] = [
  { key: 0, text: 'Non renseigné', value: 0 },
  { key: 1, text: 'Convention-type PACS', value: 1 },
  { key: 2, text: 'Convention spécifique', value: 2 },
];

export const OPTIONS_AIDE_MATERIELLE: CasCode[] = [
  { key: 0, text: 'Non renseigné', value: 0 },
  { key: 1, text: 'Proportionnelle à nos facultés respectives', value: 1 },
  { key: 2, text: 'Fixé à la hauteur de ', value: 2 },
  { key: 3, text: 'Autre', value: 3 },
];

export const OPTIONS_REGIME_BIEN: CasCode[] = [
  { key: 0, text: 'Non renseigné', value: 0 },
  {
    key: 1,
    text: 'Le régime légal de la séparation des patrimoines',
    value: 1,
  },
  {
    key: 2,
    text: "Le régime de l'indivision des biens que nous acquerrons, ensemble ou séparément, à partir de l'enregistrement du PACS",
    value: 2,
  },
  { key: 3, text: 'Autre', value: 3 },
];

export const OPTIONS_ATTESTATION_LIEN_PARENTE: CasCode[] = [
  { key: 0, text: 'Non renseigné', value: 0 },
  {
    key: 1,
    text: "Aucun lien de parenté ou d'alliance qui constituerait un empêchement pour conclure un pacte civil de solidarité (PACS)",
    value: 1,
  },
];

/** Clé du cas « Fixé à la hauteur de » (aide matérielle chiffrée). */
export const AIDE_MATERIELLE_FIXE = 2;

/** Nombre de caractères maximum du montant de l'aide fixée (comme sur etcv). */
export const VALEUR_AIDE_MAX_LENGTH = 7;

/** Clé du cas « Proportionnelle à nos facultés respectives ». */
export const AIDE_MATERIELLE_PROPORTIONNELLE = 1;

/** Clés du régime des biens : séparation des patrimoines (légal) / indivision. */
export const REGIME_BIEN_LEGAL = 1;
export const REGIME_BIEN_INDIVISION = 2;
